import { render, staticRenderFns } from "./VacationDetail.vue?vue&type=template&id=0d74a3c4&scoped=true&"
import script from "./VacationDetail.vue?vue&type=script&lang=js&"
export * from "./VacationDetail.vue?vue&type=script&lang=js&"
import style0 from "./VacationDetail.vue?vue&type=style&index=0&id=0d74a3c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d74a3c4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VContainer,VFlex,VLayout})
